import { useMemo, useState } from "react";
import Card, { CardBody, CardHeader } from "../../components/shared/card";
import ErrorDisplay from "../../components/shared/ErrorDisplay";
import HarperLoadingSpinner from "../../components/shared/HarperLoadingSpinner";
import Typography from "../../components/shared/typography";
import { useGetCalls } from "../hooks/useGetCalls";
import { CallMessagesPanel } from "./CallMessagesPanel";
import { CallList } from "./CallList";

const DEFAULT_PAGE_SIZE = 50;

export default function CallsLayout() {
  const params = useMemo(
    () => ({ limit: DEFAULT_PAGE_SIZE, offset: 0 }),
    []
  );
  const { data = [], isLoading, isError } = useGetCalls(params);
  const [selectedCallId, setSelectedCallId] = useState<string | null>(null);

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <HarperLoadingSpinner />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6 space-y-2">
        <Typography variant="h3" className="text-terracotta">
          Calls
        </Typography>
        <Typography variant="body2" className="text-brown-700">
          Recent voice call activity from the call service.
        </Typography>
      </div>

      {isError ? (
        <ErrorDisplay
          title="Unable to load calls"
          description="Please try again in a moment."
          tone="warning"
        />
      ) : (
        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)]">
          <Card>
            <CardHeader divider>
              <div className="flex items-center justify-between">
                <Typography variant="subtitle1">Latest calls</Typography>
                <Typography variant="body2" className="text-brown-600">
                  {data.length} total
                </Typography>
              </div>
            </CardHeader>
            <CardBody>
              {data.length === 0 ? (
                <Typography variant="body2" className="text-brown-600">
                  No calls found yet.
                </Typography>
              ) : (
                <CallList
                  items={data}
                  selectedId={selectedCallId}
                  onSelect={setSelectedCallId}
                />
              )}
            </CardBody>
          </Card>
          <CallMessagesPanel callId={selectedCallId ?? undefined} />
        </div>
      )}
    </div>
  );
}
